// extracted by mini-css-extract-plugin
export default {"wrapper":"inpostMap_wrapper__s9gHx"};